export const PAYER_REPORT_PREVIEW_PAGES = [
  { page: 1, title: 'Cover' },
  { page: 2, title: 'Executive Summary' },
  { page: 3, title: 'Payer Analysis' },
  { page: 4, title: 'Prime Payer Statistics' },
  { page: 5, title: 'Prime Payer Sales' },
  { page: 6, title: 'Prime Payer Aging' },
  { page: 7, title: 'Approved Payer Analysis' },
  { page: 8, title: 'Approved Payer Statistics' },
  { page: 9, title: 'Approved Payer Sales' },
  { page: 10, title: 'Approved Payer Aging' },
  { page: 11, title: 'Conclusion & Recommendations' },
  { page: 12, title: 'Appendix — Prime Payer Criteria' }
];

export const PAYER_REPORT_PREVIEW_PAGE_COUNT = PAYER_REPORT_PREVIEW_PAGES.length;

/** Pages with preview on top and full-width table editor below */
export const PAYER_REPORT_FULL_WIDTH_TABLE_PAGES = [4, 5, 6, 8, 9, 10];

export const PAYER_REPORT_TITLE = 'Kema Payer Assessment Report';
